export default __webpack_public_path__ + "static/media/banner_help.b6b78e18.png";